<template>
  <div>
    <el-tag
      v-for="(tag, index) in dynamicTags"
      :key="tag + index"
      size="small"
      :type="tagType"
      :closable="!disableRemove"
      :class="{'tags-disabled': disabled}"
      :close-transition="false"
      @close="handleClose(tag)"
    >
      {{ tag }}
    </el-tag>

    <input
      type="text"
      :placeholder="placeholder"
      class="form-control input-new-tag"
      v-model="inputValue"
      ref="saveTagInput"
      size="mini"
      @input="onInput"
      @keyup.enter="handleInputConfirm"
      @blur="handleInputConfirm"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import { Tag } from 'element-ui';

export default {
  name: 'tags-input',
  components: {
    [Tag.name]: Tag
  },
  props: {
    value: {
      type: [Array, String],
      default: () => [],
      description: 'List of tags'
    },
    tagType: {
      type: String,
      default: 'primary',
      description: 'Tag type (primary|danger etc)'
    },
    placeholder: {
      type: String,
      default: 'Add new tag',
      description: 'to replace default placeholder'
    },
    disabled: {
      type: Boolean,
      default: false,
      description: 'Determines whether the tag input field is disabled. If true, the field will be uneditable.'
    },
    disableRemove: {
      type: Boolean,
      default: false,
      description: 'Disables the ability to remove a tag or item. If true, the remove button will not be displayed.'
    },
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    };
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.$emit('change', this.dynamicTags);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;

      if(inputValue.trim() == ''){
        return;
      }

      if (inputValue) {
        this.dynamicTags.push(inputValue);
        this.$emit('change', this.dynamicTags);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    onInput(evt) {
      if(evt.target.value.trim() == ''){
        return;
      }
      this.$emit('input', evt.target.value);
    }
  },
  created() {
    this.$watch(
      'value',
      newVal => {
        this.dynamicTags = [...newVal];
      },
      { immediate: true }
    );
  }
};
</script>

<style>
.tags-disabled {
  background-color: rgb(192, 196, 204) !important;
  border-color: rgb(192, 196, 204) !important;
}
</style>
